import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=0deaeb3e"
import script from "./Segment.vue?vue&type=script&lang=js"
export * from "./Segment.vue?vue&type=script&lang=js"
import style0 from "./Segment.vue?vue&type=style&index=0&id=0deaeb3e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports